module.exports = __webpack_public_path__ + "img/mor-read_01.a2747683.jpg";